import { Outlet } from 'react-router-dom'

function ManageQueueConfig() {
  return (
    <div className="h-[100%]">
      <Outlet />
    </div>
  )
}

export default ManageQueueConfig
